import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { RootfileProvider, useRootfileStore } from '../store';

const propTypes = {
  match: PropTypes.object,
};

const RootfileForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit } } = useRootfileStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(() => {
    history.push('/cms/settings/rootfiles');
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Root File ${message}.`)
      handleCloseSidebar()
    } catch {
      handleError('Error', 'Root File was not saved.')
    }
  }, [handleCloseSidebar, handleSubmit, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleCloseSidebar() }}
    title={item.id ? 'Edit Root File' : 'Add Root File'}>
    <Helmet title='Root File' />
    <Form data={item} handleSubmit={handleSubmitAndClose} />
  </DefaultSheet>
})

RootfileForm.propTypes = propTypes

export default function RootfileFormLayout() {
  return <RootfileProvider>
    <RootfileForm />
  </RootfileProvider>
}
